import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { maintenanceService } from 'shared/services';
import CloseMaintenanceDialog from '../components/dialog/CloseMaintenanceDialog';
import { LinkButton } from 'components/ui';
import { MaintenanceColumns } from '../maintenances';

export const ExpiringMaintenances = () => {
  const translationPrefix = 'pages.maintenance-expiring';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [open, setOpen] = useState(false);
  const [maintenanceToCloseId, setMaintenanceToCloseId] = useState<number | null>(null);

  const setOpenDialog = (id: number) => {
    setOpen(true);
    setMaintenanceToCloseId(id);
  };
  const setCloseDialog = () => {
    setOpen(false);
    setMaintenanceToCloseId(null);
  };

  const columns: GridColDef[] = MaintenanceColumns(setOpenDialog, 'expiration');

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <LinkButton to="without-date" label={t(`${translationPrefix}.button-without-date`)} />
      }>
      <EnhancedDataGrid
        columns={columns}
        service={maintenanceService}
        getMethod={maintenanceService.getExpiringMaintenances}
        refresh={datagridRefresh}
      />
      <CloseMaintenanceDialog
        onClose={setCloseDialog}
        datagridRefresh={datagridRefresh}
        maintenanceId={maintenanceToCloseId}
        isOpen={open}
      />
    </TenantPage>
  );
};

export default ExpiringMaintenances;
